import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseTintColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-tint-color-panel';
import type {RGBA} from '@Utils/color.util';
import {useAppSelector} from '@/hooks';

export function ImageBgTintColorPanel(): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const onUpdateColor = (tintColor: RGBA, undoable = true): void => {
    if ('imageBackgroundItemObject' in currentPageObject.background.details) {
      void currentPage?.background.updateFromObject(
        {
          details: {
            imageBackgroundItemObject: {
              effects: {
                tintColor,
              },
            },
          },
        },
        {undoable}
      );
    } else {
      throw new Error('imageBackgroundItemObject does not exist in page background details');
    }
  };

  return <BaseTintColorPanel tintColor={currentPageObject.background.details.imageBackgroundItemObject.effects.tintColor} onUpdateTintColor={onUpdateColor} />;
}
